import '../../../blocks/faq/app';
